(() => {
  if (customElements.get('sh-faq-page')) return;
  customElements.define('sh-faq-page', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.input = this.querySelector('[data-faq-search]');
      this.groups = [...this.querySelectorAll('[data-faq-group]')];
      this.items = [...this.querySelectorAll('[data-faq-item]')];
      this.savedOpen = null;
      this.input.addEventListener('input', () => this.filter());
      this.querySelector('[data-faq-clear]').addEventListener('click', () => {
        this.input.value = ''; this.filter(); this.input.focus();
      });
      this.querySelectorAll('[data-faq-jump]').forEach(link => link.addEventListener('click', () => {
        this.input.value = ''; this.filter();
        const target = this.querySelector(link.getAttribute('href'));
        if (target) target.querySelector('h3')?.focus({ preventScroll: true });
      }));
      this.filter();
    }
    filter() {
      const query = this.input.value.trim().toLocaleLowerCase();
      if (query && !this.savedOpen) this.savedOpen = new Set(this.items.filter(item => item.open));
      let count = 0;
      this.items.forEach(item => {
        const match = !query || item.textContent.toLocaleLowerCase().includes(query);
        item.hidden = !match;
        if (match) count++;
        if (query) item.open = match;
        else if (this.savedOpen) item.open = this.savedOpen.has(item);
      });
      if (!query) this.savedOpen = null;
      this.groups.forEach(group => {
        const visible = [...group.querySelectorAll('[data-faq-item]')].filter(item => !item.hidden).length;
        group.hidden = visible === 0;
        group.querySelector('[data-faq-count]').textContent = visible;
      });
      this.querySelector('[data-faq-empty]').hidden = count > 0;
      this.querySelector('[data-faq-clear]').hidden = !query;
      this.querySelector('[data-faq-status]').textContent = query ? `${count} ${this.dataset.resultsLabel}` : '';
    }
  });
})();
